import type { MiddlewareParams } from '~/middleware'

export const guestMiddleware = async ({ oidcStore, options }: MiddlewareParams) => {
  if (oidcStore.oidcUser)
    return options.redirect.home

  return true
}
